<script>
	import Board from './Board.svelte'
</script>
	
<style>
	#game{
		display: grid;
		place-items: center;
	}
</style>
<div id="game">
	<Board/>	
</div>
